import { VoidCallback } from 'types/callbacks';
import styles from './RemixModalContainer.module.css';
import { memo, ReactNode } from 'react';
import Rive, { Fit, Layout, Alignment } from '@rive-app/react-webgl2';
import { RiveModal, RiveModalCloseIcon } from 'components/common/RiveModal';
import { getRemixingPath } from 'lib/community';

type Props = {
  display: boolean;
  onClose: VoidCallback;
  children: ReactNode;
};

const RemixModalContainer = ({ display, onClose, children }: Props) => {
  const layout = new Layout({ fit: Fit.Cover, alignment: Alignment.TopCenter });

  return (
    <RiveModal onClose={onClose} display={display}>
      <div className={styles.Container}>
        <RiveModalCloseIcon onClose={onClose} />
        <div className={styles.Animation}>
          <Rive src={'/static/riv/remix_animation.riv'} layout={layout} />
        </div>
        <div className={styles.Content}>{children}</div>
      </div>
    </RiveModal>
  );
};

export default memo(RemixModalContainer);

type RemixModalActionsProps = {
  children: ReactNode;
};

export function RemixModalActions({ children }: RemixModalActionsProps) {
  return <div className={styles.Actions}>{children}</div>;
}

type RemixModalWarningProps = {
  children: ReactNode;
};
export function RemixModalWarning({ children }: RemixModalWarningProps) {
  return (
    <div className={styles.Warning}>
      <div className={styles.WarningIcon}>
        <img src={'/static/warning.png'} />
      </div>

      <div className={styles.WarningContent}>{children}</div>
    </div>
  );
}

export function WhatIsRemixing() {
  return (
    <>
      <p>
        Remix a community shot to save it to your drafts and add your own
        creative flair. Publish your remix to the community to feature alongside
        the original.{' '}
        <a href={getRemixingPath()} target="_blank" rel="noopener noreferrer">
          Learn more
        </a>{' '}
        about remixing.
      </p>
    </>
  );
}
